class VariantPriceUpdater {
  constructor(variantMetafields) {
    this.variantMetafields = variantMetafields;
    this.showApproxPrice = window.showApproxPrice !== undefined ? window.showApproxPrice : true; // Default to true if not set
    this.init();
  }

  init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setup());
    } else {
      this.setup();
    }
  }

  setup() {
    // Don't set up anything if approximate price display is disabled
    if (!this.showApproxPrice) return;
    
    this.setupEventListeners();
    this.updateInitialPrice();
  }

  setupEventListeners() {
    this.setupVariantSelectors();
    this.setupVariantInputObserver();
  }

  setupVariantSelectors() {
    // Radio button variant selectors
    document.querySelectorAll('input[type="radio"][name^="Size"]').forEach(radio => {
      radio.addEventListener('change', () => this.delayedVariantChange());
    });

    // Dropdown variant selectors
    document.querySelectorAll('select[name^="options"]').forEach(select => {
      select.addEventListener('change', () => this.delayedVariantChange());
    });
  }

  setupVariantInputObserver() {
    const variantInput = document.querySelector('input[name="id"]');
    if (!variantInput) return;

    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
          this.handleVariantChange();
        }
      });
    });

    observer.observe(variantInput, { attributes: true });
  }

  delayedVariantChange() {
    setTimeout(() => this.handleVariantChange(), 100);
  }

  handleVariantChange() {
    const variantInput = document.querySelector('input[name="id"]');
    if (!variantInput) return;
    this.updateApproximatePrice(variantInput.value);
  }

  updateInitialPrice() {
    // Don't update if approximate price display is disabled
    if (!this.showApproxPrice) return;

    // Check for current variant from window object first
    if (window.currentVariant && window.currentVariant.id) {
      this.updateApproximatePrice(window.currentVariant.id);
      return;
    }

    // Fallback to input value if window.currentVariant is not available
    const variantInput = document.querySelector('input[name="id"]');
    if (!variantInput) return;
    
    // If the input has a value, use it
    if (variantInput.value) {
      this.updateApproximatePrice(variantInput.value);
    } else {
      // If no variant is selected, try to get the first available variant's price
      const firstVariantId = Object.keys(this.variantMetafields)[0];
      if (firstVariantId) {
        this.updateApproximatePrice(firstVariantId);
      }
    }
  }

  updateApproximatePrice(variantId) {
    // Don't update if approximate price display is disabled
    if (!this.showApproxPrice) return;

    const variantMetafield = this.variantMetafields[variantId];
    const priceElement = document.querySelector('.product__price-wrapper-pdp-price');
    if (!priceElement) return;

    let approxPriceWrapper = priceElement.querySelector('.product__price-approx-price-wrapper');
    let approxPriceDetails;

    if (!approxPriceWrapper && variantMetafield?.approximate_price) {
      ({ approxPriceWrapper, approxPriceDetails } = this.createPriceElements(priceElement));
    } else if (approxPriceWrapper) {
      approxPriceDetails = approxPriceWrapper.querySelector('.product__price-approx-price-details');
    }

    if (variantMetafield?.approximate_price && approxPriceWrapper && approxPriceDetails) {
      approxPriceDetails.textContent = variantMetafield.approximate_price;
      approxPriceWrapper.style.display = '';
    } else if (approxPriceWrapper) {
      approxPriceWrapper.style.display = 'none';
    }
  }

  createPriceElements(priceElement) {
    const approxPriceWrapper = document.createElement('div');
    approxPriceWrapper.className = 'product__price-approx-price-wrapper';
    
    const approxPriceLabel = document.createElement('p');
    approxPriceLabel.className = 'product__price-approx-price';
    approxPriceLabel.textContent = 'Approximate Price';
    
    const approxPriceDetails = document.createElement('p');
    approxPriceDetails.className = 'product__price-approx-price-details';
    
    approxPriceWrapper.appendChild(approxPriceLabel);
    approxPriceWrapper.appendChild(approxPriceDetails);
    priceElement.appendChild(approxPriceWrapper);

    return { approxPriceWrapper, approxPriceDetails };
  }
} 